"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SentenceStore = /*#__PURE__*/function (_RootStore) {
  function SentenceStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, SentenceStore);
    _this = _callSuper(this, SentenceStore);
    _this.config = {
      model: _models.Sentence,
      deserialize: true,
      GET: {
        index: '/sentences',
        show: '/sentences/:sentenceId'
      },
      PUT: {
        update: '/sentences/:sentenceId',
        updateLiteralSource: '/sentences/:sentenceId/update_literal_source',
        mergeChildren: '/sentences/:sentenceId/merge_children',
        validate: '/sentences/:sentenceId/validate',
        removeConcept: '/sentences/:sentenceId/remove_concept',
        carryOverMedia: 'sentences/:sentenceId/carry_over_media',
        mergeSentenceWords: '/sentences/:sentenceId/merge_sentence_words',
        updateAiTranslations: '/sentences/:sentenceId/update_ai_translations'
      },
      POST: {
        create: '/sentences',
        smartyTokens: '/sentences/smarty_tokens'
      },
      DELETE: {
        destroy: '/sentences/:sentenceId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(SentenceStore, _RootStore);
  return (0, _createClass2["default"])(SentenceStore, [{
    key: "removeConcept",
    value: function removeConcept(data, callback) {
      this.api({
        ids: {
          sentenceId: this.showData.id
        },
        data: data
      }, callback, 'PUT', 'removeConcept');
    }
  }, {
    key: "mergeChildren",
    value: function mergeChildren(associations) {
      j;
      this.api({
        ids: {
          sentenceId: this.showData.id
        },
        data: {
          associations: associations
        }
      }, this.reloadShow.bind(this), 'PUT', 'mergeChildren');
    }
  }, {
    key: "smartyTokens",
    value: function smartyTokens(params, callback) {
      this.api(params, callback, 'POST', 'smartyTokens');
    }
  }, {
    key: "carryOverMedia",
    value: function carryOverMedia(params, callback) {
      this.api(params, callback, 'PUT', 'carryOverMedia');
    }
  }, {
    key: "updateLiteralSource",
    value: function updateLiteralSource(params, callback) {
      this.api(params, callback, 'PUT', 'updateLiteralSource');
    }
  }, {
    key: "validate",
    value: function validate(ids) {
      this.api({
        ids: ids
      }, this.reloadShow.bind(this), 'PUT', 'validate');
    }
  }, {
    key: "mergeSentenceWords",
    value: function mergeSentenceWords(params, callback) {
      this.api(params, callback, 'PUT', 'mergeSentenceWords');
    }
  }, {
    key: "updateAiTranslations",
    value: function updateAiTranslations(params, callback) {
      this.api(params, callback, 'PUT', 'updateAiTranslations');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new SentenceStore();